import { render, staticRenderFns } from "./EnumerationManagement.vue?vue&type=template&id=13881506"
import script from "./EnumerationManagement.vue?vue&type=script&lang=js"
export * from "./EnumerationManagement.vue?vue&type=script&lang=js"
import style0 from "./EnumerationManagement.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports